var _path, _path2, _path3, _path4, _path5, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7326 25.06V31.9267C40.7326 36.0333 38.386 37.7933 34.866 37.7933H23.146C22.546 37.7933 21.9726 37.74 21.4393 37.62C21.106 37.5667 20.786 37.4734 20.4926 37.3667C18.4926 36.62 17.2793 34.8867 17.2793 31.9267V25.06C17.2793 20.9533 19.626 19.1934 23.146 19.1934H34.866C37.8526 19.1934 39.9993 20.46 40.5726 23.3534C40.666 23.8867 40.7326 24.4333 40.7326 25.06Z",
    stroke: "#AED100",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7347 29.0601V35.9268C44.7347 40.0335 42.3881 41.7935 38.8681 41.7935H27.1481C26.1614 41.7935 25.2681 41.6602 24.4948 41.3669C22.9081 40.7802 21.8281 39.5669 21.4414 37.6202C21.9747 37.7402 22.5481 37.7935 23.1481 37.7935H34.8681C38.3881 37.7935 40.7347 36.0335 40.7347 31.9268V25.0601C40.7347 24.4335 40.6814 23.8735 40.5747 23.3535C43.1081 23.8868 44.7347 25.6735 44.7347 29.0601Z",
    stroke: "#AED100",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9966 32.0198C30.9406 32.0198 32.5166 30.4438 32.5166 28.4998C32.5166 26.5557 30.9406 24.9797 28.9966 24.9797C27.0525 24.9797 25.4766 26.5557 25.4766 28.4998C25.4766 30.4438 27.0525 32.0198 28.9966 32.0198Z",
    stroke: "#AED100",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.373 25.5667V31.4333",
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6289 25.5671V31.4338",
    stroke: "#8C8C8C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 60,
    height: 60,
    rx: 28,
    stroke: "#EAEAEA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.260d636bef8d355d5ad4905f72e6deac.svg";
export { ForwardRef as ReactComponent };